<template>
	<div class="customer">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col >
		
			<!--<b-row class="breadcrumbrow"><b-col>			
			<a v-if="!statusSidebar" href="javascript:void(0)" id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'">	<i class="fa fa-arrow-left" style="font-size:24px"></i> Close Menu</a>
			<a v-else href="javascript:void(0)"  id="menu-toggle" @click="burgerMenuSidebar" v-b-toggle="'sidebar-fifi-toggle'"><i class="fa fa-bars" aria-hidden="true" style="font-size:24px"></i></a>
			</b-col></b-row> -->
			
		<b-container fluid class="p-0 mt-2" >
		
			<mywish-list></mywish-list>
		
		</b-container>
		
		
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import MywishList from "@/components/mywish-list.vue";
//import ProfileBank from "@/components/profile-bank.vue";
//import ProfileAccount from "@/components/profile-account.vue";
//import ProfileBusiness from "@/components/profile-business.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		
		"mywish-list": MywishList,
		/*"profile-bank": ProfileBank,
		"profile-business": ProfileBusiness, */
	},
	mounted(){
		//var self = this;
       // Object.assign(self.selectedItem, self.emptyItem);
        
		//this.initProfile();
	},
	data() {
            return{
            loading: false, 
            recordUrl: this.$root.WEBURL+'categoryproducts',
            updateUrl: this.$root.NEWAPIURL+'sellerapi/update-profile',
            categoryOptions: [],
            breadcrumb: [
                    {
                        text: 'Home',
                        href: '/'
                    },
                    {
                        text: 'Products',
                        active: true
                    }
            ],
            
            
		};
    },
	methods: {
		
	}
}
</script>
<!-- scoped  -->
<style scoped lang="scss">

</style>